<template>
    <div class="company-list">
        <div class="grid-row">
            <div class="c-6 c-md-6 c-sm-12 c-xs-12" v-for="company in companies" :key="company.company_id">
                <Company :companyinfo="company"/>
            </div>
            <div class="valid-container c-12">
                <a class="btn" @click="vCompanySelect">{{$_('validate_choice')}}</a>
            </div>
        </div>
    </div>
</template>

<script>

import Company from './Company'

import companyService from '@/modules/societe/services/companyService'

export default {
  data() {
    return {
      companies: Array(),
      selectedValue: ''
    }
  },
  created() {
    companyService.getCompany()
    .then(res => {
      res.data.DS_O.OUT.map((company) => {
        this.companies.push(company)
      })
    })
    .catch(err => {
      console.error(err)
    })
  },
  components: {
    Company
  },
  methods: {
    vCompanySelect(){
      this.$store.dispatch('application/SATABAPP_STORE', {key: 'satabapp-company', val: this.selectedValue})
      this.$router.push('/')
    }
  },
  watch: {
    companies() {
      if (this.companies.length === 1) {
        this.selectedValue = this.companies[0];
        this.vCompanySelect();
      }
    }
  }
}
</script>

<style scoped>

.valid-container {
  margin-top: 50px;
}
</style>